<template>
    <div class="amazon-div">
        <p class="font-title"> 慧智创新亚马逊服务 API 的使用政策</p>
        <div class="amazon-content">
            <p class="font-sub">我们将严格遵守亚马逊以下的使用政策：</p>
            <div class="content-txt">
                <p class="txt-title">1. 执行可接受的亚马逊活动</p>
                <P class="txt-desc">
                    亚马逊服务 API 适用于希望帮助授权用户在亚马逊商店中建立、管理和发展成功业务和/或参与任何亚马逊服务的开发人员。
                </P>
                <p class="faq">1.1 仅将亚马逊服务 API 用于执行可接受的亚马逊活动，并且仅供已授权您代表他们执行这些活动的授权用户使用。</p>
                <p class="faq">1.2 不得直接或间接促进或助长违反授权用户与亚马逊之间的任何协议（例如亚马逊服务业务解决方案协议）。</p>
                <p class="faq">1.3 如果您怀疑授权用户使用您的服务违反他们与亚马逊的协议，请通知亚马逊 (spapi-abuse@amazon.com) 并阻止授权用户访问您的应用程序。</p>
                <p class="faq">1.4 遵守与您的应用程序提供的特定 API 或功能相关的亚马逊政策。</p>
            </div>
            <div class="content-txt">
                <p class="txt-title">2. 提供优质的应用和服务</p>
                <P class="txt-desc">透明度</P>
                <p class="faq">2.1 不得虚假宣传您的应用程序或服务。</p>
                <p class="faq">2.2 向授权用户清楚、诚实地说明您正在访问哪些数据以及出于什么目的。</p>
                <p class="faq">2.3 不要试图通过故意修改信息来欺骗授权用户。</p>
                <p class="faq">2.4 明确说明您提供的服务中的任何计算和人工智能等模型的使用、其准确性和数据新鲜度。</p>
                <P class="txt-desc">遵守</P>
                <p class="faq">2.5 遵守所有适用法律，包括数据隐私和数据保护法（例如 GDPR、中华人民共和国网络安全法）。</p>
                <p class="faq">2.6 不得提供侵犯他人版权、专利或商标的应用程序或服务。</p>
                <P class="txt-desc">质量和性能</P>
                <p class="faq">2.7 提供执行业务任务所需的应用程序可用性、性能和支持。</p>
                <p class="faq">2.8 在启动新功能之前识别并减轻任何对授权用户的负面影响，尤其是对于业务关键型任务。</p>
                <p class="faq">2.9 设计您的应用程序以尊重每个授权用户的限制配额。</p>
                <p class="faq">2.10 在您的应用程序中对任何对授权用户的业务有重大影响的分析处理（例如，用于洞察力的 AI 模型、自动决策制定）实施数据完整性和验证检查。</p>
            </div>
            <div class="content-txt">
                <p class="txt-title">3. 确保数据安全</p>
                <P class="txt-desc">帐户访问</P>
                <p class="faq">3.1 切勿共享访问密钥或密码。</p>
                <p class="faq">3.2 不得出于任何目的请求或接受授权用户或其他开发者的访问密钥。</p>
                <p class="faq">3.3 不得向授权用户请求或共享亚马逊门户用户名或密码。</p>
                <p class="faq">3.4 仅代表通过第三方授权授予您许可的授权用户行事。</p>
                <p class="faq">3.5 请勿申请您不会使用的访问密钥。 Amazon 将每 90 天设置一次访问密钥基线。 90天内未调用成功的访问密钥将被删除，开发者需要重新申请访问密钥。</p>
                <p class="faq">3.6 不得要求授权用户手动或以编程方式共享从亚马逊门户检索的信息以规避亚马逊政策。</p>
                <p class="faq">3.7 如果需要访问亚马逊门户以提供有利于授权用户的功能或服务，请要求授权用户通过二级用户权限授予访问权限。</p>
                <P class="txt-desc">资料存取</P>
                <p class="faq">3.8 请勿请求访问或检索您的应用程序功能不需要的信息。</p>
                <p class="faq">3.9 仅在您的组织内、您的组织雇用或签约的任何个人以及您的应用程序用户之间授予对数据的“需要知道”的访问权限。</p>
                <p class="faq">3.10 不要试图通过在同一区域内创建多个开发者帐户来规避限制配额。</p>
                <p class="faq">3.11 在 30 天内通知亚马逊 (3p-security@amazon.com) 任何组织变更或事件会改变您的组织对信息的需求或使用。</p>
                <p class="faq">3.12 向亚马逊披露您的应用程序或服务中涉及的附属实体。</p>
                <p class="faq">3.13 遵守数据保护政策（“DPP”），该政策对信息的接收、存储、使用、传输和处置提出了具体要求。</p>
            </div>
            <div class="content-txt">
                <p class="txt-title">4. 将数据用于可接受的目的</p>
                <p class="txt-desc">数据使用</p>
                <p class="faq">4.1 不得将有关客户的个人身份信息用于商户履行运输或满足法律要求（包括税收和监管要求）以外的任何目的。 您必须向授权用户记录处理个人身份信息的任何要求。</p>
                <p class="faq">4.2 不得使用通过亚马逊服务 API 或任何外部（非亚马逊）数据服务检索的数据以亚马逊客户为目标进行产品营销或审查制造和修改。</p>
                <p class="faq">4.3 不得使用、提供或推广外部（非亚马逊）数据服务</p>
                <p class="faq">4.4 不得汇总通过亚马逊服务 API 获得的授权用户业务或客户的数据，以提供或出售给任何一方，包括竞争授权用户。</p>
                <p class="faq">4.5 不得宣传、发布或分享有关亚马逊业务的见解。 请勿将有关亚马逊业务的见解用于您自己的业务目的。</p>
                <p class="txt-desc">数据共享</p>
                <p class="faq">4.6 不要向其他应用程序用户、关联实体或任何外部方披露单独标记或汇总的信息，除非需要为授权您的应用程序的授权用户执行可接受的授权用户活动。</p>
                <p class="faq">4.7 对与您共享数据的任何一方的数据安全措施和政策进行尽职调查，仅与数据安全标准至少与您一样严格的各方共享数据。</p>
                <p class="faq">4.8 根据适用法律的要求，转让 PII 的开发商必须制定合同条款，为此类转让提供适当的法律依据。</p>
                <p class="faq">4.9 对授权用户保持透明，说明您共享哪些数据、与谁共享以及出于何种目的。</p>
            </div>
            <div class="content-txt">
                <p class="txt-title">5. API 特定政策</p>
                <p class="faq">5.1 如果您支持使用买卖双方消息服务进行买卖双方消息传递，则您必须遵守通信指南。</p>
                <p class="faq">5.2 如果您使用买家与卖家消息服务，您还必须通过与消息和请求 API 的集成来支持亚马逊批准的模板。</p>
                <p class="faq">5.3 如果您使用商户履行API，您必须遵守商户履行API服务条款。</p>
                <p class="faq">5.4 如果您使用亚马逊货运服务 API，您必须遵守亚马逊货运服务 API 条款。</p>
                <p class="faq">5.5 如果您使用亚马逊商业 API，您必须遵守技术集成协议及其附录的条款，或适用的亚马逊商业账户条款和条件。</p>
            </div>
        </div>
        <mainBottom></mainBottom>
    </div>
</template>
<script>
import mainBottom from "@/components/container/bottom";
export default {
    components: { mainBottom },
};
</script>
<style scoped>
.amazon-div {
    width: 100%;
    height: auto;
    background-color: #ededed;
    /* #f6f6f8; */
    padding-top: 60px;
}

.amazon-content {
    margin-top: 120px;
    border-radius: 10px;
    background-color: #fffeff;
    width: 75%;
    padding: 60px 0px;
    margin: 0 auto;
    /* font-family: MADE TOMMY; */
    margin-bottom: 45px;
}

.font-title {
    font-size: 34px;
    text-align: center;
    font-weight: 600;
    padding: 40px 0px;
}

.content-txt {
    margin: 0px 100px;
    width: 80%;
    margin: 0 auto;
    border-bottom: 1px solid rgb(188, 188, 188);
    padding: 35px 0px;
    text-align: left;
}

.txt-title {
    font-size: 20px;
    color: #000;
    /* font-family: "MADE TOMMY"; */
}

.font-sub {
    font-size: 20px;
    padding-left: 145px;
    font-weight: bold;

}

.txt-desc {
    font-size: 16px;
    color: #000;
    padding: 10px 0;
}

.faq {
    font-size: 16px;
    color: #555;
    line-height: 25px;
}
</style>
  
  